import React from 'react';
import ReactDOM from 'react-dom';

import App from './components/App/App';
import reportWebVitals from './reportWebVitals';
import { bootstrapGtm, getGtmId } from './utils/analytics';

const gtmId = getGtmId();
if (gtmId) bootstrapGtm(gtmId);

ReactDOM.render(
    <App />,
    document.getElementById('root')
);

if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/sw.js');
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
